import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
const RemoveButton = ({ className, confirm, onRemove })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SimpleTooltip, {
        usePortal: true,
        text: t('gruser.widgetbox.button.remove')
    }, /*#__PURE__*/ React.createElement(IconButton, {
        icon: TrashcanIcon,
        variant: "edit-purple",
        size: "medium",
        onClick: confirm ? ()=>confirm(onRemove) : onRemove,
        className: className,
        "data-role": "edit-control",
        biData: BiData({
            evid: 280,
            widgetname: BiContextProvidedValue,
            widgetzone: BiContextProvidedValue
        }),
        "aria-label": t('gruser.widgetbox.button.remove')
    }));
};
RemoveButton.displayName = 'RemoveButton';
export default RemoveButton;
